import { BulkActionErrorCode } from "@common/constants/financial-documents";
import { z } from "zod";

export const InvalidDocumentCategoryErrorSchema = z.object({
    code: z.literal(BulkActionErrorCode.INVALID_DOCUMENT_CATEGORY),
});

export type InvalidDocumentCategoryError = z.infer<
    typeof InvalidDocumentCategoryErrorSchema
>;
